import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ErrorBoundary from './components/ErrorBoundary';
import HomePage from './components/HomePage';
import HowToUsePage from './components/HowToUsePage';
import FeaturesPage from './components/FeaturesPage';
import FAQPage from './components/FAQPage';
import GoogleLocationChangerPage from './components/GoogleLocationChangerPage';
import PrivacyPage from './components/PrivacyPage';
import TermsPage from './components/TermsPage';
import CookiesPage from './components/CookiesPage';
import NotFound from './components/NotFound';
import './App.css';

// The router lives outside App: BrowserRouter in src/index.js (browser) and
// StaticRouter in src/ssr.js (build-time prerender), so both render the same tree.
export const PRERENDER_ROUTES = ['/', '/how-to-use', '/features', '/faq', '/google-location-changer', '/privacy', '/terms', '/cookies'];

function App() {
  return (
    <ErrorBoundary>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/how-to-use" element={<HowToUsePage />} />
          <Route path="/features" element={<FeaturesPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/google-location-changer" element={<GoogleLocationChangerPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/cookies" element={<CookiesPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
    </ErrorBoundary>
  );
}

export default App; 